export default __webpack_public_path__ + "static/media/notes-medical.167800bd.svg";